import classes from 'components/common/charts/heatmapChart/heatmapChart.module.scss';
import Chart from 'react-apexcharts';
import NoData from 'components/common/NoData/noData';
import OverlayWithSpinner from 'components/common/OverlayWithSpinner/overlayWithSpinner';
import { memo } from 'react';

interface Props {
    options: ApexCharts.ApexOptions;
    series: ApexAxisChartSeries | ApexNonAxisChartSeries | undefined;
    isFetching?: boolean;
    noData?: boolean;
    height?: number;
    className?: string;
}

export const HeatmapChart = memo(
    ({ isFetching = false, noData = false, options, series, height = 600, className = '' }: Props) => {
        return (
            <div className={`${classes.container} ${className}`} data-testid={'heatmap-chart-container'}>
                {isFetching && <OverlayWithSpinner />}
                {noData && <NoData />}
                {!noData && <Chart options={options} series={series} type="heatmap" height={height} />}
            </div>
        );
    },
);
